import React, { memo } from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

interface EmailTextFieldProps  {
    fieldsErrors: FieldErrors;
    register: UseFormMethods['register'];
    label: string;
}

export const EmailTextField = memo(({ register, fieldsErrors, label }: EmailTextFieldProps) => {
    const { t } = useTranslation();

    return (
        <StyledTextfield
            id='email'
            name='email'
            type='text'
            label={label}
            helperText={fieldsErrors.email ? fieldsErrors.email.message : null}
            size='small'
            variant='outlined'
            autoFocus
            fullWidth
            inputRef={register({
                required: {
                    value: true,
                    message: t('emailErrorMessage')
                },
                pattern: {
                    value: emailRegex,
                    message: t('invalidEmail')
                }
            })}
            error={!!fieldsErrors.email}
        />
    );
});

const StyledTextfield = styled(TextField)`
    margin-bottom: 20px;
    
    .MuiFormLabel-root.Mui-error {
        color: #000000;
        opacity: .2;
    }
    
    .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: #000000;
        opacity: .2;
    }
`;